
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[sector]",
      function () {
        return require("private-next-pages/categories/[sector].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categories/[sector]"])
      });
    }
  